import { Component, Input, ViewChildren, QueryList, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/mode/xml/xml.js';
import { copyToClipboard} from '../../shared-module/common/functions/file-helpers';
import { ScriptingLanguageType } from '../../shared-module/cpq-scripting-codemirror/cpq-scripting.model';
import { CpqScriptingCodemirrorComponent } from '../../shared-module/cpq-scripting-codemirror/cpq-scripting-codemirror.component';


@Component({
    selector: 'playbook-cart',
    templateUrl: './playbook-cart.component.html',
    styleUrls: ['./playbook-cart.component.scss'],
    standalone: false
})
export class PlayBookCartComponent implements OnInit {
  @ViewChildren('editor', { read: CpqScriptingCodemirrorComponent }) editor: QueryList<CpqScriptingCodemirrorComponent>;
  @Input('title') title = "";
  @Input('codeContentHTML') htmlCode;
  @Input('codeContentTS') tsCode;

  public showCode: boolean;
  public tsLanguageType = ScriptingLanguageType.TypeScript;
  public htmlLanguageType = ScriptingLanguageType.Html;
  public tsScript;
  public htmlScript;

  constructor() {}

  ngOnInit() {
    this.tsScript = { script: this.tsCode, forceProxyGeneration: false };
    this.htmlScript = { script: this.htmlCode, forceProxyGeneration: false };
  }

  toggle() {
    this.showCode = !this.showCode;
  }

  public onTabChange(event: MatTabChangeEvent) {
    this.editor.forEach((child) => child.refreshInstance());
  }

  public copyCode(value: string) {
     copyToClipboard(value);
    }
}
